module.exports = __webpack_public_path__ + "frontend/images/favicons/android-chrome-512x512.png?e57a5438f4bf39b4d09aac37a07e43dd";